import './badge-list.scss';
import classNames from 'classnames';
import { isEqual } from 'lodash';
import React from 'react';
import ReactResizeDetector from 'react-resize-detector';
import { Badge } from '../Badge';
const marginBottom = 4;
export class BadgeList extends React.Component {
    constructor(props) {
        super(props);
        this.setWrapperRef = (element) => {
            this.wrapperRef = element;
        };
        this.setRemainderRef = (element) => {
            this.remainderRef = element;
        };
        this.getBadgeHeight = () => {
            const ref = this.wrapperRef;
            if (ref) {
                const firstChild = ref.childNodes[0];
                if (!firstChild) {
                    return 0;
                }
                const badgeHeight = firstChild.scrollHeight;
                const margin = parseInt(window.getComputedStyle(firstChild).getPropertyValue('margin-bottom'), 10);
                return badgeHeight + margin;
            }
            return 0;
        };
        this.filterBadges = () => {
            const { filteredBadges } = this.state;
            const { badges, maxRows, maxBadges } = this.props;
            if (maxBadges && maxBadges > 0) {
                this.setState({
                    wrapperHeight: undefined,
                    remainder: badges.length - maxBadges,
                    filteredBadges: filteredBadges.length !== maxBadges
                        ? badges.slice(0, maxBadges)
                        : filteredBadges,
                });
                return;
            }
            const ref = this.wrapperRef;
            if (ref) {
                if (this.remainderRef) {
                    ref.removeChild(this.remainderRef);
                }
                const tops = [];
                // eslint-disable-next-line @typescript-eslint/prefer-for-of
                for (let i = 0; i < ref.childNodes.length; i++) {
                    const child = ref.childNodes[i];
                    tops.push(child.offsetTop);
                }
                const uniqueTops = Array.from(new Set(tops));
                const maxRowsReached = uniqueTops.length >= maxRows;
                const finalTop = maxRowsReached
                    ? uniqueTops[maxRows - 1]
                    : uniqueTops[uniqueTops.length - 1];
                const wrapperHeight = finalTop + this.getBadgeHeight() - marginBottom;
                const remainder = tops.filter((top) => top > finalTop).length;
                const lastChild = ref.childNodes[tops.length - remainder];
                ref.insertBefore(this.remainderRef, lastChild);
                const isRemainderOverflown = this.remainderRef?.offsetTop >= wrapperHeight;
                if (isRemainderOverflown) {
                    ref.removeChild(this.remainderRef);
                    const prevChild = ref.childNodes[tops.length - remainder - 1];
                    ref.insertBefore(this.remainderRef, prevChild);
                    this.setState({ remainder: remainder + 1 });
                }
                else {
                    this.setState({ remainder });
                }
                this.setState({ wrapperHeight, filteredBadges: badges });
            }
        };
        this.renderRemainder = () => {
            const { borderRadius, layout, size, font, onClickMore, background } = this.props;
            const cursorClass = onClickMore ? 'pointer' : '';
            const borderClass = background ? '' : 'no-border';
            const backgroundClass = background ? '' : 'no-background';
            const remainderClass = classNames('remainder', layout ? layout : '', size ? size : '', backgroundClass, cursorClass, borderClass);
            if (this.state.remainder > 0) {
                return (React.createElement("div", { onClick: onClickMore, className: remainderClass, style: {
                        borderRadius,
                        fontFamily: font,
                    } },
                    "+",
                    this.state.remainder));
            }
            return React.createElement("div", null);
        };
        const { maxBadges, badges } = props;
        this.state = {
            wrapperHeight: 0,
            remainder: 4,
            filteredBadges: maxBadges && maxBadges > 0 ? badges.slice(0, maxBadges) : props.badges,
        };
    }
    async componentDidMount() {
        this.filterBadges();
    }
    componentDidUpdate(prev) {
        if (isEqual(this.props, prev)) {
            return;
        }
        this.filterBadges();
    }
    render() {
        const { filteredBadges } = this.state;
        const { layout, size, borderRadius, font, background, align, hideDefaultIcon, className, } = this.props;
        const backgroundClass = background ? '' : 'no-background';
        const wrapperClass = classNames('badge-list-wrapper', layout ? layout : '', size ? size : '', align ? align : '', backgroundClass, className);
        return (React.createElement(ReactResizeDetector, { handleWidth: true, handleHeight: true, onResize: this.filterBadges }, () => (React.createElement("div", { className: "members-badge-list-lib-style-wrapper" },
            React.createElement("div", { className: wrapperClass, ref: this.setWrapperRef, style: { height: this.state.wrapperHeight } },
                filteredBadges.map((badge) => (React.createElement(Badge, { key: badge.id, badge: badge, layout: layout, size: size, borderRadius: borderRadius, font: font, background: background, onLoadIcon: this.filterBadges, onClick: this.props.onBadgeClick, hideDefaultIcon: hideDefaultIcon }))),
                React.createElement("span", { ref: this.setRemainderRef }, this.renderRemainder()))))));
    }
}
//# sourceMappingURL=BadgeList.js.map